/**
 * AlertBanner — DS Molecule
 * 4 niveaux : info / success / warning / danger
 */

import { useState } from 'react';
import styles from './AlertBanner.module.css';

type AlertVariant = 'info' | 'success' | 'warning' | 'danger';

const ICONS: Record<AlertVariant, string> = {
  info: 'bi-info-circle-fill',
  success: 'bi-check-circle-fill',
  warning: 'bi-exclamation-triangle-fill',
  danger: 'bi-x-circle-fill',
};

interface AlertBannerProps {
  variant?: AlertVariant;
  title?: string;
  children: React.ReactNode;
  dismissible?: boolean;
  className?: string;
}

export function AlertBanner({ variant = 'info', title, children, dismissible = false, className = '' }: AlertBannerProps) {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;
  return (
    <div className={`${styles.alert} ${styles[variant]} ${className}`} role="alert">
      <i className={`bi ${ICONS[variant]} ${styles.icon}`} />
      <div className={styles.content}>
        {title && <div className={styles.title}>{title}</div>}
        <div className={styles.body}>{children}</div>
      </div>
      {dismissible && (
        <button className={styles.dismiss} onClick={() => setDismissed(true)} aria-label="Fermer">
          <i className="bi bi-x" />
        </button>
      )}
    </div>
  );
}
